import React, {Component} from 'react';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import styles from './styles.css';

export default class CLMultiplierHome extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='Campo Líder Multiplicador' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar
                        refundType='cl'
                        userType='multiplier'
                        links={['crops', 'refund', 'kits', 'trialSigns']}
                    />
                    <div className={styles.message}>
                        <p>Realizá tu pedido</p>
                        <p>Para garantizar la entrega correcta del kit de materiales se debe solicitar con 10 días
                         hábiles de anticipación
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/cl-multiplier/home/index.js